/**
 * checkout finish  (Jetzt Kaufen)
 */

import * as loader from "@shopJS/loader";
import * as rest from "@sharedJS/rest";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";
import pushDataLayer from "@ocm/services/dataLayer.js";

let $body;
let isClicked;

function init() {
	isClicked = false;

	$body = $("body");
	$body.on("click", ".js-checkout-finish-btn", (evt) => {
		if (!isClicked) {
			isClicked = true;
			loader.addLoader($("body"));
			evt.preventDefault();
			let $form;

			_trackBuyNowTopBtn();

			if ($(this).context) {
				$form = $(this).parent("form:first");
			} else {
				// workaround for vue 3
				$form = $(evt.currentTarget).parent("form:first");
			}
			window.history.replaceState(null, null, `?orderId=${$("input[name=orderId]")[0].value}`);
			_submitCheckout($form);
		}

		OcmMessenger.subscribe(messengerPublicationTypes.CHECKOUT_SUMMARY_LOADED, _disableLoadingIndicators);
	});
}

function _trackBuyNowTopBtn() {
	const { pagePath } = window.recommendationData.Recommendation.pageData;
	pushDataLayer({
		event: "GAevent",
		event_category: "S_checkout",
		event_action: "S_buy_now_top",
		event_label: `S_${pagePath}`,
	});
}

function _submitCheckout(form) {
	const context = {
		form,
		callback: _submitCheckout,
		callbackData: form,
		saveRedirectToHistory: true,
	};
	rest.submitForm(context);
}

function _disableLoadingIndicators() {
	const checkoutFinishButton = document.querySelector(".js-checkout-finish-btn");
	const checkoutLoader = document.querySelector(".js-cartSummary-loader");

	if (checkoutFinishButton) {
		checkoutFinishButton.disabled = false;
	}

	if (checkoutLoader) {
		checkoutLoader.style.display = "none";
	}
}

export { init };
